import moment from 'moment';
// export const getTimeFormatted = (time, t) => {
//   let timeFormatted = "";

//   const timestamp = moment(time);
//   const timeNow = moment();

//   const isSameDate = moment(timeNow.format("YYYY-MM-DD")).isSame(
//     timestamp.format("YYYY-MM-DD")
//   );
//   const diff = moment.duration(timeNow.diff(timestamp));

//   if (isSameDate) {
//     if (diff.hours() > 0) {
//       const unit = diff.hours() > 1 ? `${t("hrs")}` : `${t("hr")}`;
//       timeFormatted = `${timestamp.format("HH:mm")} (${diff.hours()} ${unit} ${t("ago")})`;
//     } else if (diff.minutes() > 0) {
//       const unit = diff.minutes() > 1 ? `${t("mins")}` : `${t("min")}`;
//       timeFormatted = `${timestamp.format("HH:mm")} (${diff.minutes()} ${unit} ${t("ago")})`;
//     } else {
//       timeFormatted = timestamp.format("HH:mm");
//     }
//   } else if (diff.days() >= 0 && diff.days() <= 1) {
//     timeFormatted = `${t("yesterday")} ${timestamp.format("HH:mm")}`;
//   } else if (diff.days() >= 1 && diff.days() <= 5) {
//     timeFormatted = `${dateName(timestamp.format("ddd"), t)} ${timestamp.format(
//       "DD/MM/YY"
//     )} (${diff.days()} ${t("days")} ${t("ago")}) ${timestamp.format("HH:mm")}`;
//   } else {
//     timeFormatted = `${dateName(timestamp.format("ddd"), t)} ${timestamp.format("DD/MM/YY")} ${timestamp.format("HH:mm")}`;
//   }

//   return timeFormatted;
// };

export const getTimeFormatted = (time, t) => {
  let timeFormatted = '';

  const timestamp = moment(time);
  const timeNow = moment();

  const isSameDate = moment(timeNow.format('YYYY-MM-DD')).isSame(timestamp.format('YYYY-MM-DD'));

  if (isSameDate) {
    timeFormatted = `${timestamp.format('HH:mm')}`;
  } else {
    timeFormatted = `${timestamp.format('DD/MM/YY')} ${timestamp.format('HH:mm')}`;
  }

  return timeFormatted;
};

export const getAlertTime = (time, t) => {
  let timeFormatted = '';

  const timestamp = moment(time);
  const timeNow = moment();

  const isSameDate = moment(timeNow.format('YYYY-MM-DD')).isSame(timestamp.format('YYYY-MM-DD'));
  const diff = moment.duration(timeNow.diff(timestamp));

  if (isSameDate) {
    timeFormatted = `${timestamp.format('HH:mm')}`;
  } else if (diff.days() === 0) {
    timeFormatted = `${diff.days() + 1} ${t('day')} ${t('ago')}`;
  } else if (diff.days() === 1) {
    timeFormatted = `${diff.days()} ${t('day')} ${t('ago')}`;
  } else {
    timeFormatted = `${diff.days()} ${t('days')} ${t('ago')}`;
  }

  return timeFormatted;
};

export function dateName(data, t) {
  let result = '';
  switch (data) {
    case 'Sun':
      result = `${t('sun')}`;
      break;
    case 'Mon':
      result = `${t('mon')}`;
      break;
    case 'Tue':
      result = `${t('tue')}`;
      break;
    case 'Wed':
      result = `${t('wed')}`;
      break;
    case 'Thu':
      result = `${t('thu')}`;
      break;
    case 'Fri':
      result = `${t('fri')}`;
      break;
    case 'Sat':
      result = `${t('sat')}`;
      break;
    default:
      result = '';
      break;
  }
  return result;
}

export function getCurrentDateTimeFormatted(date, language) {
  const newDate = moment(date).format('YYYY-MM-DD HH:mm');
  const dateTime = newDate.split(' ');
  const datePart = dateTime[0].split('-');
  // const year = language === "th-TH" ? +datePart[0] + 543 : datePart[0];
  const year = +datePart[0] + 543;
  const month = datePart[1];
  const day = datePart[2];
  return day + '/' + month + '/' + year + ' ' + dateTime[1];
}

export function getCurrentDateBuddhistFormatted(date) {
  const newDate = moment(date).format('YYYY-MM-DD');
  const dateTime = newDate.split(' ');
  const datePart = dateTime[0].split('-');
  const year = +datePart[0] + 543;
  const month = datePart[1];
  const day = datePart[2];
  return day + '/' + month + '/' + year;
}

export function getDateTimeFormatted(date) {
  const dateTime = date && date.split(' ');
  const datePart = dateTime[0].split('/');
  const years = +datePart[2] - 543;
  const months = datePart[1];
  const days = datePart[0];

  return `${years}-${months}-${days} ${dateTime[1]}`;
}

export const fixedEmergencyDate = (date, t) => {
  let dateFormatted = '';
  const dateNow = moment();
  const isSameDate = moment(dateNow.format('YYYY-MM-DD')).isSame(date);

  const diff = moment.duration(dateNow.diff(date));
  const days = diff.days();

  if (isSameDate) {
    dateFormatted = `${moment(date).format('DD/MM/YYYY')}, ${t('today')}`;
  } else if (days > 3) {
    dateFormatted = `${moment(date).format('DD/MM/YYYY')}`;
  } else if (days > 0) {
    dateFormatted = `${moment(date).format('DD/MM/YYYY')}, ${days} ${t('day')} ${t('ago')}`;
  }

  return dateFormatted;
};

export const fixedEmergencyTime = (time) => {
  const timestamp = moment(time).format('HH:mm');
  return timestamp;
};
